import React, { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import * as S from "./index-styled";
import PT from "prop-types";
import Controls from "./Controls";
import { IS_BROWSER } from "@/misc/constants";
import Sticky from "./Sticky";
import loadable from "@loadable/component";
import { useSearchUrlGenerator } from "@/hooks/useSearchUrlGenerator";
import { useHistory } from "react-router";
import { GeoService } from "@/services/geo";

const Map = loadable(
  () => import(/* webpackChunkName: "search-map" */ "./Map"),
  { ssr: false }
);

const defaultCoords = {
  lat: 0,
  lng: 0,
};
const Aside = ({
  query,
  masters,
  mapPopup,
  openMapPopup,
  closeMapPopup,
  toggleMap,
  isMapOpen,
  isFiltersOpen,
  isMobile,
  toggleFilters,
  locale,
  coords,
  mapFocus,
  resultsLength,
  params,
  t,
}) => {
  const generateSearchUrl = useSearchUrlGenerator();
  const history = useHistory();
  const [loc, setLoc] = useState(coords);
  useEffect(() => {
    setLoc(coords ? coords : defaultCoords);
  }, [coords]);
  const isDesktop = !isMobile;
  const changeLocation = useCallback(
    async ({ lat, lng }) => {
      setLoc({
        lat,
        lng,
      });
      let address_label = query.address_label;
      try {
        const { name, city, fullName } = await GeoService.reverseGeocode({
          lat,
          lng,
        });
        address_label = city || name || fullName;
      } catch (e) {
        console.error(e);
      }
      const url = generateSearchUrl({
        query: {
          ...query,
          address_label,
          page: 0,
          lat,
          lng,
          spec: params?.spec || query.spec,
        },
      });
      history.push(url);
    },
    [query, params]
  );
  return (
    <Sticky resultsLength={resultsLength} isDesktop={isDesktop}>
      <S.Wrap>
        {isDesktop && (
          <Controls
            t={t}
            toggleMap={toggleMap}
            isMapOpen={isMapOpen}
            isFiltersOpen={isFiltersOpen}
            toggleFilters={toggleFilters}
          />
        )}
        {(isDesktop || isMapOpen) &&
          IS_BROWSER &&
          (isDesktop ? (
            <Map
              t={t}
              changeLocation={changeLocation}
              mapFocus={mapFocus}
              mapPopup={mapPopup}
              openMapPopup={openMapPopup}
              closeMapPopup={closeMapPopup}
              masters={masters}
              radius={Number(query.radius)}
              lat={loc.lat}
              lng={loc.lng}
              locale={locale}
            />
          ) : (
            createPortal(
              <Map
                t={t}
                locale={locale}
                mapFocus={mapFocus}
                mapPopup={mapPopup}
                openMapPopup={openMapPopup}
                closeMapPopup={closeMapPopup}
                masters={masters}
                radius={Number(query.radius)}
                lat={loc.lat}
                lng={loc.lng}
                changeLocation={changeLocation}
              />,
              document.getElementById("root")
            )
          ))}
      </S.Wrap>
    </Sticky>
  );
};
Aside.propTypes = {
  query: PT.object,
  masters: PT.array,
  mapPopup: PT.object,
  isMapOpen: PT.bool,
  isFiltersOpen: PT.bool,
  specs: PT.array,
  locale: PT.string,
  coords: PT.object,
  isMobile: PT.bool,
  params: PT.object,
  resultsLength: PT.number,

  t: PT.func.isRequired,
  toggleMap: PT.func.isRequired,
  openMapPopup: PT.func.isRequired,
  closeMapPopup: PT.func.isRequired,
  toggleFilters: PT.func.isRequired,
};

export default Aside;
